module.exports = __webpack_public_path__ + "img/Dentist.1868772e.png";